import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '@/config';

interface SubscriptionData {
  coins: number;
  status: string;
  loading: boolean;
  error: string | null;
}

export const useSubscriptionCheck = () => {
  const [subscriptionData, setSubscriptionData] = useState<SubscriptionData>({
    coins: 0,
    status: 'NO_SUBSCRIPTION',
    loading: true,
    error: null,
  });

  const fetchSubscriptionData = async () => {
    try {
      setSubscriptionData(prev => ({ ...prev, loading: true, error: null }));
      
      const token = localStorage.getItem('accessToken');
      const res = await axios.get(
        `${config.NEXT_PUBLIC_BASE_URL}/api/users/coins`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (res.status === 200) {
        setSubscriptionData({
          coins: parseInt(res.data.shredsCoins) || 0,
          status: res.data.status || 'NO_SUBSCRIPTION',
          loading: false,
          error: null,
        });
      } else {
        setSubscriptionData(prev => ({
          ...prev,
          loading: false,
          error: 'Failed to fetch subscription data',
        }));
      }
    } catch (error) {
      setSubscriptionData(prev => ({
        ...prev,
        loading: false,
        error: 'Failed to fetch subscription data',
      }));
    }
  };

  useEffect(() => {
    fetchSubscriptionData();
  }, []);

  const hasValidSubscriptionOrCredits = () => {
    const { coins, status } = subscriptionData;
    return (
      status === 'ACTIVE' || 
      status === 'ACTIVE_UNTIL_PERIOD_END' || 
      coins > 0
    );
  };
  
  const hasValidSubscription = () => {
    const { status } = subscriptionData;
    return (
      status === 'ACTIVE' ||
      status === 'ACTIVE_UNTIL_PERIOD_END'
    );
  };

  const refetch = () => {
    fetchSubscriptionData();
  };

  return {
    ...subscriptionData,
    hasValidSubscriptionOrCredits,
    hasValidSubscription,
    refetch,
  };
};